import {
  CustomFieldType,
  type CustomFieldSchema,
  CustomFieldValidators,
  RelationTypeOptions,
  DateTypeOptions,
} from '@tribeplatform/gql-client/types'

import { CustomFieldSubtype } from '../../CustomField/utils.js'
import { CustomFieldValidatorPattern } from '../../CustomFields/utils.js'

export const initialTextField: CustomFieldSchema = {
  key: 'initialTextField',
  name: 'Text field',
  type: CustomFieldType.text,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.TEXT),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
    {
      key: 'placeholder',
      value: JSON.stringify('Placeholder'),
    },
  ],
}
export const initialTextareaField: CustomFieldSchema = {
  key: 'initialTextareaField',
  name: 'Textarea',
  type: CustomFieldType.text,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.TEXTAREA),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
    {
      key: 'placeholder',
      value: JSON.stringify('Placeholder'),
    },
  ],
}
export const initialUrlField: CustomFieldSchema = {
  key: 'initialUrlField',
  name: 'URL field',
  type: CustomFieldType.text,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.URL),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
    {
      key: 'placeholder',
      value: JSON.stringify('Placeholder'),
    },
  ],
  validators: [
    {
      validation: CustomFieldValidators.pattern,
      value: JSON.stringify(CustomFieldValidatorPattern.URL),
      customErrorMessage: 'Links should start with https://',
    },
  ],
}
export const initialEmailField: CustomFieldSchema = {
  key: 'initialEmailField',
  name: 'Email field',
  type: CustomFieldType.text,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.EMAIL),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
    {
      key: 'placeholder',
      value: JSON.stringify('Placeholder'),
    },
  ],
  validators: [
    {
      validation: CustomFieldValidators.pattern,
      value: JSON.stringify(CustomFieldValidatorPattern.EMAIL),
      customErrorMessage: 'Please enter a valid email address',
    },
  ],
}
export const initialNumberField: CustomFieldSchema = {
  key: 'initialNumberField',
  name: 'Number field',
  type: CustomFieldType.number,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.NUMBER),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
    {
      key: 'placeholder',
      value: JSON.stringify('Placeholder'),
    },
  ],
}
export const initialRichtextField: CustomFieldSchema = {
  key: 'initialRichtextField',
  name: 'Richtext field',
  type: CustomFieldType.richText,
  settings: [
    { key: 'subtype', value: JSON.stringify(CustomFieldSubtype.HTML) },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
    {
      key: 'placeholder',
      value: JSON.stringify('Placeholder'),
    },
  ],
}
export const initialOptionField: CustomFieldSchema = {
  key: 'initialOptionField',
  name: 'Option field',
  type: CustomFieldType.text,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.SELECT),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
    {
      key: 'placeholder',
      value: JSON.stringify('Placeholder'),
    },
  ],
  validators: [
    {
      validation: CustomFieldValidators.enum,
      value: JSON.stringify([]),
    },
  ],
}
export const initialOptionsField: CustomFieldSchema = {
  key: 'initialOptionsField',
  name: 'Options field',
  type: CustomFieldType.array,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.MULTISELECT),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
    {
      key: 'placeholder',
      value: JSON.stringify('Placeholder'),
    },
  ],
  items: {
    key: 'options',
    name: 'Options',
    type: CustomFieldType.text,
    validators: [
      {
        validation: CustomFieldValidators.enum,
        value: JSON.stringify([]),
      },
    ],
  },
}
export const initialDateField: CustomFieldSchema = {
  key: 'initialDateField',
  name: 'Date field',
  type: CustomFieldType.date,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.DATE),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
  ],
  typeOptions: {
    dateType: DateTypeOptions.date,
  },
}
export const initialDateTimeField: CustomFieldSchema = {
  key: 'initialDateTimeField',
  name: 'Date & time field',
  type: CustomFieldType.date,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.DATETIME),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
  ],
  typeOptions: {
    dateType: DateTypeOptions.datetime,
  },
}
export const initialToggleField: CustomFieldSchema = {
  key: 'initialToggleField',
  name: 'Toggle field',
  type: CustomFieldType.boolean,
  default: JSON.stringify(false),
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.TOGGLE),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
  ],
}
export const initialCheckboxField: CustomFieldSchema = {
  key: 'initialCheckboxField',
  name: 'Checkbox',
  type: CustomFieldType.boolean,
  default: JSON.stringify(false),
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.CHECKBOX),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
  ],
}
export const initialImageField: CustomFieldSchema = {
  key: 'initialImageField',
  name: 'Image field',
  type: CustomFieldType.relation,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.IMAGE),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
  ],
  typeOptions: {
    relationType: RelationTypeOptions.Media,
  },
}
export const initialImagesField: CustomFieldSchema = {
  key: 'initialImagesField',
  name: 'Images field',
  type: CustomFieldType.array,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.IMAGES),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
  ],
  items: {
    key: 'images',
    name: 'Images',
    type: CustomFieldType.relation,
    typeOptions: {
      relationType: RelationTypeOptions.Media,
    },
  },
}
export const initialFileField: CustomFieldSchema = {
  key: 'initialFileField',
  name: 'File field',
  type: CustomFieldType.relation,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.FILE),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
  ],
  typeOptions: {
    relationType: RelationTypeOptions.Media,
  },
}
export const initialFilesField: CustomFieldSchema = {
  key: 'initialFilesField',
  name: 'Files field',
  type: CustomFieldType.array,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.FILES),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
  ],
  items: {
    key: 'files',
    name: 'Files',
    type: CustomFieldType.relation,
    typeOptions: {
      relationType: RelationTypeOptions.Media,
    },
  },
}
export const initialMemberField: CustomFieldSchema = {
  key: 'initialMemberField',
  name: 'Member field',
  type: CustomFieldType.relation,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.MEMBER),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
    {
      key: 'placeholder',
      value: JSON.stringify('Placeholder'),
    },
  ],
  typeOptions: {
    relationType: RelationTypeOptions.Member,
  },
}
export const initialMembersField: CustomFieldSchema = {
  key: 'initialMembersField',
  name: 'Members field',
  type: CustomFieldType.array,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.MEMBERS),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
  ],
  items: {
    key: 'members',
    name: 'Members',
    type: CustomFieldType.relation,
    typeOptions: {
      relationType: RelationTypeOptions.Member,
    },
  },
}
export const initialSpaceField: CustomFieldSchema = {
  key: 'initialSpaceField',
  name: 'Space field',
  type: CustomFieldType.relation,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.SPACE),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
    {
      key: 'placeholder',
      value: JSON.stringify('Placeholder'),
    },
  ],
  typeOptions: {
    relationType: RelationTypeOptions.Space,
  },
}
export const initialSpacesField: CustomFieldSchema = {
  key: 'initialSpacesField',
  name: 'Spaces field',
  type: CustomFieldType.array,
  settings: [
    {
      key: 'subtype',
      value: JSON.stringify(CustomFieldSubtype.SPACES),
    },
    {
      key: 'helperText',
      value: JSON.stringify('Helper text'),
    },
  ],
  items: {
    key: 'spaces',
    name: 'Spaces',
    type: CustomFieldType.relation,
    typeOptions: {
      relationType: RelationTypeOptions.Space,
    },
  },
}

export const defaultInitialSingleField = initialTextField
export const defaultInitialMultipleField = initialOptionsField
